import React from 'react';
import ProductPage from '../components/product/ProductPage';
import { personalVaultConfig } from '../config/products';

const PersonalVaultPage: React.FC = () => {
  return <ProductPage config={personalVaultConfig} />;
};

export default PersonalVaultPage;
